import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { ExdInfoTip } from "./ExdControls";
import {
  getKpiTheme,
  KpiCardShell,
  KpiCardValue,
  KpiHeader,
  KpiMeter,
  KpiPill,
  KpiSkeleton,
  KpiSubRow,
} from "./kpiMui";

const ActiveAccountsCard = ({
  loading,
  translate,
  accountsData,
  infoTitle,
  accent = "risk",
}) => {
  if (loading) return <KpiSkeleton />;

  const theme = getKpiTheme(accent);
  const oldAccounts = parseInt(accountsData?.oldAccounts) || 0;
  const newAccounts = parseInt(accountsData?.newAccounts) || 0;
  const totalAccounts = parseInt(accountsData?.totalAccounts) || 0;
  const totalActiveAccount=totalAccounts-accountsData?.inactiveAccounts??0
  const isPositive =
    accountsData?.oldAccounts + accountsData?.newAccounts >
    accountsData?.inactiveAccounts;
  const activePercent =
    Math.abs(
      (
        ((accountsData?.totalAccounts - accountsData?.inactiveAccounts) /
          accountsData?.totalAccounts) *
        100
      )?.toFixed(0),
    ) || 0;

  return (
    <KpiCardShell accent={accent}>
      <KpiHeader
        title={translate("Active Accounts")}
        info={<ExdInfoTip title={infoTitle} tone={theme.infoTone} />}
      />

      <Tooltip
        title={
          <Typography sx={{ fontSize: 14 }}>
            {totalActiveAccount?.toLocaleString() || ""}
          </Typography>
        }
      >
        <Box>
          <KpiCardValue theme={theme}>{totalActiveAccount}</KpiCardValue>
        </Box>
      </Tooltip>

      <KpiMeter
        value={Math.min(Math.max(activePercent, 0), 100)}
        theme={theme}
      />

      <KpiSubRow>
        <KpiPill
          variant={isPositive ? "good" : "bad"}
          onDark={theme.infoTone === "onDark"}
        >
          {isPositive ? "▲" : "▼"} {activePercent}% {translate("Active")}
        </KpiPill>
      </KpiSubRow>

      <KpiSubRow sx={{ color: theme.muted }}>
        <Typography component="span" sx={{ fontSize: "inherit", color: "inherit" }}>
          New{" "}
          <Box component="b" sx={{ color: theme.color }}>
            {newAccounts}
          </Box>
        </Typography>
        <Typography component="span" sx={{ fontSize: "inherit", color: "inherit" }}>
          All{" "}
          <Box component="b" sx={{ color: theme.color }}>
            {totalAccounts}
          </Box>
        </Typography>
      </KpiSubRow>
    </KpiCardShell>
  );
};

export default ActiveAccountsCard;
